import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './EmailVerification.css';
import Util from './ait/Util.js';
import Swal from 'sweetalert2';


const EmailVerification = ({auth, onLogout}) => {
  const [error, setError] = useState(''); // State to hold the error message
  const [success, setSuccess] = useState(''); // State to hold the error message
  const navigate = useNavigate();

  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include", // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };
  
  useEffect(() => {
    
    if(auth.user.sysPage != true)
    {
      if(auth.user.inactive==false)
      {
          navigate('/subscription-setup');
      }
      else
      {
          setError("Email is not verified yet");  
      }
    }
    else
    {
      // no need to verify system pages
      navigate('/dashboard');
    }
      // If the function has any side effects, you can also clean up after it
    return () => {
      // Optional cleanup if needed
      console.log('Cleaning up when MyComponent is unmounted');
    };
  }, []); // The empty dependency array means it only runs once, when the component is mounted



  const handleVerification = () => {
    // Simulate email verification logic (you can replace this with actual logic)    

    window.location.reload();
    
  };

  const handleResendEmail = async() => {

      const command = Util.serverName + "/protected/sendVerificationEmail"; // Base API endpoint
      setError('');
      setSuccess('');

        // Make the API call using POST method with a JSON body
      try
      {    
        const response = await fetchWithAuth(command, {
            method: 'POST', // Use POST method
            headers: { 'Content-Type': 'application/json' }, // Specify JSON format
            body: JSON.stringify({}), // JSON payload
          })
        const data = await response.json(); // Parse the JSON response

        if (!response.ok) {
          setError(data.message);
          return;

        }

        if (!data.status) {
          setError(data.message);
          return;
        }       

        Swal.fire({
          title: 'Info',
          text: "Verification Email Sent!!",
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });        

        setSuccess("Verification Email Sent")

      }
      catch(error)
      {
          setError(error.message);

          return;
      }
      finally {
      }    
  };

  return (
    <div className="email-verification-container">
      <div className="email-verification-content">
        <h1 className="email-verification-title">Email Verification</h1>
        <p className="email-verification-message">
          Check your email for a verification link. Once verified, click below to proceed.
        </p>
        
        {error && <div className="error-message">{error}</div>} {/* Display error message if there's any */}
        {success && <div className="success-message">{success}</div>} {/* Display error message if there's any */}

        <button className="verification-button" onClick={handleVerification}>
          I Have Verified My Email
        </button>
        <button className="resend-button" onClick={handleResendEmail}>
          Resend Email
        </button>
      </div>
    </div>
  );
};

export default EmailVerification;


